import { useState } from "react"
import { Sku } from "../../api/models"

// Builds a responsive srcset from the base image URL and the CDN's available
// widths, swapping the trailing -<width> suffix. Mirrors the helper used on the
// Product/Sku pages.
export function buildImageSrcSet(url: string, availableWidths?: number[]): string | undefined {
  if (!availableWidths || availableWidths.length === 0) return undefined
  return availableWidths
    .map((w) => `${url.replace(/-\d+(\.\w+)$/, `-${w}$1`)} ${w}w`)
    .join(", ")
}

// The header image for a store/offer card. Renders nothing when the sku
// has no image, so callers can drop it in unconditionally.
export default function SkuImage({ sku, alt }: { sku: Sku, alt: string }) {
  // Right after an upload the scaler hasn't produced the width variants yet,
  // so the srcset-picked one can 404 while the original already exists —
  // retry with the original alone (per-URL, so a later image_url gets its
  // srcset back).
  const [fallbackUrl, setFallbackUrl] = useState<string | null>(null)
  if (!sku.imageUrl) return null
  const srcSet = fallbackUrl === sku.imageUrl ? undefined : buildImageSrcSet(sku.imageUrl, sku.availableWidths)
  return (
    <img
      src={sku.imageUrl}
      srcSet={srcSet}
      sizes="300px"
      alt={alt}
      className="store-card-img"
      loading="lazy"
      onError={() => setFallbackUrl(sku.imageUrl!)}
    />
  )
}
